export interface IConfirmationState {
  username: string;
  password: string;
  passwordConfirmation: string;
}

const ConfirmationState: IConfirmationState = {
  username: '',
  password: '',
  passwordConfirmation: ''
};

export default ConfirmationState;
